/* eslint-disable new-cap */
import { Images } from '@abcya/abcya_phaser';
import AudioPlayer from '../library/AudioPlayer';
import OrbitingSprite from './OrbitingSprite';


export default class StarBase extends OrbitingSprite {
  constructor(scene, x, y, text) {
    super();
    this.scene = scene;
    this.x = x;
    this.y = y;

    this.cont = scene.add.container(x, y);
    this.starButton = Images.addImage(0, 0, 'starBase', this.scene);
    this.starButton.setInteractive({ useCursor: true });
    this.starButton.on('pointerdown', () => {
      this.OnDown();

      this.scene.input.once('pointerup', () => {
        this.OnUp();
      });
    });

    this.sprite = this.cont;

    let starText;
    this.cont.add(this.starButton);

    if (text) {
      starText = this.scene.add.bitmapText(0, 14, 'Nasalization', text, 35);
      starText.align = 'center';
      starText.setOrigin(.5);
      starText.tint = 0x1b0a37;

      this.cont.add(starText);
    }
  }

  OnClick() {
    AudioPlayer.PlaySound(this.scene, AudioPlayer.sounds.CLICK);
  }

  AnimateOut() {

  }

  OnDown() {
    // this.sprite.children[0].x = -8;
    // this.sprite.children[0].y = 26;
    this.starButton.setFrame('starBase_Depressed');
  }

  OnUp() {
    // this.sprite.children[0].x = 0;
    // this.sprite.children[0].y = 20;
    this.starButton.setFrame('starBase');
  }
}


